import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [mustChangePassword, setMustChangePassword] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/auth/me')
        .then(u => {
          setUser(u);
          setMustChangePassword(u.must_change_password || false);
        })
        .catch(() => { localStorage.removeItem('token'); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const data = await api.post('/auth/login', { email, password });
    localStorage.setItem('token', data.token);
    // /auth/me로 권한 포함 전체 정보 로드
    const fullUser = await api.get('/auth/me');
    setUser(fullUser);
    setMustChangePassword(fullUser.must_change_password || false);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setMustChangePassword(false);
  };

  const passwordChanged = () => {
    setMustChangePassword(false);
    if (user) setUser({ ...user, must_change_password: false });
  };

  const refreshUser = async () => {
    try { const u = await api.get('/auth/me'); setUser(u); } catch(e) {}
  };

  // preferences 부분 갱신 — PUT /auth/preferences 후 user 객체와 동기화하여
  // 페이지 이동 후에도 즐겨찾기 등 설정이 유지되도록.
  const updateUserPreferences = (prefs) => {
    setUser(u => u ? { ...u, preferences: { ...(u.preferences || {}), ...prefs } } : u);
  };

  return (
    <AuthContext.Provider value={{ user, loading, mustChangePassword, login, logout, passwordChanged, refreshUser, updateUserPreferences }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
